export default __webpack_public_path__ + "static/media/akasa.89b4d418.svg";